import styled from "styled-components";
import { COLORS } from "theme";
import Flex from "components/Flex";

export const ResumeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
`;

export const ResumeCard = styled.div`
  background: ${COLORS.WHITE};
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ResumeLeft = styled(Flex)`
  gap: 15px;
  align-items: center;
  flex: 1;    
  min-width: 0;
`;

export const ResumeFileName = styled.div`
  font-weight: 600;
  color: ${COLORS.GREY_T_10};
  font-size: 14px;
  white-space: normal;    
  word-break: break-word;
`;

export const ResumeDate = styled.div`
  font-size: 12px;
  color: ${COLORS.GREY_T_60};
`;

export const ResumeActions = styled.div`
  display: flex;
  gap: 20px;

  span {
    cursor: pointer;
    display: flex;
    align-items: center;

    svg {
      width: 20px;
      height: 20px;
      stroke: ${COLORS.GREY_T_60};
    }
  }
`;

export const SetDefaultPill = styled.div`
  background: #3249d7;
  color: white;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  width: max-content;
  user-select: none;

  &:hover {
    opacity: 0.9;
  }
`;

export const FileTypeBadge = styled.div`
  width: 48px;
  height: 32px;
  border-radius: 8px;
  background: ${(props) =>
    props.type === "pdf" ? "#E96555" : "#4A6CF7"};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 12px;
`;

export const SystemResumeCard = styled(ResumeCard)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 16px;
`;

export const SystemLeft = styled(Flex)`
  gap: 12px;
  align-items: center;

  img {
    width: 40px;
    height: 40px;
  }
`;

export const SystemBadge = styled.div`
  background: #E5EBFF;
  color: #3A57E8;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 8px;
`;

export const ResumeLimitNote = styled.div`
  margin-top: 10px;
  padding: 12px;
  background: #ffecec;
  border-radius: 8px;
  color: #c45a5a;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #f5b7b7;
  line-height: 20px;
`;

export const UploadButtonWrapper = styled.div`
  margin-top: 12px;
`;
